import { find, keyBy, map, round, sortBy } from 'lodash';
import humps from 'lodash-humps';
import { distanceBetweenLocation } from '@/utils';

const state = {
    places: [],
    postalCode: '',
    postalCodeIsValid: false,
    postalCodeFromPortal: false,
    selectedPlacePanel: '',
    selectedPlaceId: '',
    isSelectedPlace: false,
    lat: null,
    lng: null,
};

const getters = {
    getPlaceById: state => {
        return keyBy(state.places, 'id');
    },
    getPlaces: state => {
        return state.places;
    },
    getPlaceIds: state => {
        return map(state.places, 'id');
    },

    getPlace: state => id => {
        return find(state.places, ['id', id]);
    },
    getPostalCode: state => {
        return state.postalCode;
    },
    getPostalCodeIsValid: state => {
        return state.postalCodeIsValid;
    },
    getPostalCodeFromPortal: state => {
        return state.postalCodeFromPortal;
    },
    getSelectedPlacePanel: state => {
        return state.selectedPlacePanel;
    },
    getIsSelectedPlace: state => {
        return state.isSelectedPlace;
    },
    getSelectedPlaceId: state => {
        return state.selectedPlaceId;
    },

    getPlacesOrderByDistance: (state, getters) => {
        if (getters.getPlacesWithDistance) {
            return sortBy(getters.getPlacesWithDistance, ['distance']);
        }
        return null;
    },

    getPlacesWithDistance: state => {
        if (state.lat && state.lng) {
            return map(state.places, place => {
                place.distance = round(distanceBetweenLocation(state.lat, state.lng, place.latitude, place.longitude));
                return place;
            });
        }
        return null;
    },
};

const mutations = {
    SET_PLACES(state, payload) {
        state.places = payload;
    },
    SET_POSTAL_CODE(state, payload) {
        state.postalCode = payload;
    },
    SET_POSTAL_CODE_IS_VALID(state, payload) {
        state.postalCodeIsValid = payload;
    },
    SET_POSTAL_CODE_FROM_PORTAL(state, payload) {
        state.postalCodeFromPortal = payload;
    },
    SET_SELECTED_PLACE_PANEL(state, payload) {
        state.selectedPlacePanel = payload;
    },
    SET_IS_SELECTED_PLACE(state, payload) {
        state.isSelectedPlace = payload;
    },
    SET_SELECTED_PLACE_ID(state, payload) {
        state.selectedPlaceId = payload;
    },
    SET_LAT(state, payload) {
        state.lat = payload;
    },
    SET_LNG(state, payload) {
        state.lng = payload;
    },
};

const actions = {
    /**
     * @description Get the list of all place for an establishment
     * @param commit
     * @param state
     * @param rootGetters
     * @returns {Q.Promise<void>}
     */
    getPlaces({ commit, state, rootGetters }) {
        const establishmentId = rootGetters['establishment/getEstablishmentId'];
        return this._vm.$api.places.getAll(establishmentId)
            .then(response => {
                const places = map(humps(response.data), (place) => {
                    const postalCodeFormatted = place.postalCode.slice(0, 3) + ' ' + place.postalCode.slice(3);
                    place.formattedAddress = place.address + ', ' + place.city + ', ' + postalCodeFormatted + ', ' + place.country;
                    return place;
                });
                commit('SET_PLACES', places);
            });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
